import styled from 'styled-components';
import { Label } from '@grnhse/seedling/lib/birch/typography';

const DividerLabel = styled(Label)<{ transparent?: boolean }>`
  && {
    word-break: unset;
    ${({ transparent }) => transparent && 'color: transparent'};
  }
`;

export default DividerLabel;
